import { CHAIN } from '@tonconnect/protocol'
import { isTestnet } from './network'

/**
 * Generates a link to the TON blockchain explorer (tonviewer.com).
 * Automatically selects testnet or mainnet explorer based on the network.
 *
 * @param path - The path to append (e.g., transaction hash or address)
 * @param network - The network from TON Connect wallet
 * @returns Full URL to the explorer
 */
export function generateExplorerLink(
  path: string,
  network: CHAIN | null,
): string {
  const baseUrl = isTestnet(network)
    ? 'https://testnet.tonviewer.com'
    : 'https://tonviewer.com'

  return `${baseUrl}/${path}`
}
